export enum ArticleStatusEnum {
  GENERATING = 1,
  COMPLETED = 2,
  ERROR = 3,
}
